module.exports = __webpack_public_path__ + "static/media/18.111.c4b7fa28.webp";